import template from './infrastructure-and-leisure.jade';
import infrastructureAndLeisureCtrl from './infrastructure-and-leisure.controller';

export default () => {
  return {
    template,
    scope: {},
    bindToController: {},
    controller: infrastructureAndLeisureCtrl,
    controllerAs: 'infrastructureAndLeisureCtrl',
    replace: true,
  };
};
